__turbopack_context__.v({
  "cell": "SelectionCell-module-scss-module__B8aoxa__cell",
  "cellDisabled": "SelectionCell-module-scss-module__B8aoxa__cellDisabled",
  "cellError": "SelectionCell-module-scss-module__B8aoxa__cellError",
  "cellSelected": "SelectionCell-module-scss-module__B8aoxa__cellSelected",
  "label": "SelectionCell-module-scss-module__B8aoxa__label",
});
